module.exports = __webpack_public_path__ + "static/petra_1_square-d9cddfc113c3034b332431754701e870.jpg";